import apiService from "./apiService";
const bookingService = {
    async getTripTicket(id){
            return await apiService.get(`v1/b/generatetripticket/${id}`, {}, true)
    },
}

export default bookingService;